import { graphql } from "gatsby";
import React from "react";
import Layout from "../components/Layout";
import PageIntro from "../components/PageIntro";
import ProductGrid from "../components/ProductGrid";

const Category = (props) => {

	const productCollection = props.data.allProducts.nodes;
	const categoryName = productCollection[0]?.category;

	return (
		<Layout hasSidebar>
			<PageIntro
				eyebrow="Portafolio"
				title={ categoryName ? categoryName.toLowerCase() : "Categoría" }
				aside={ `${productCollection.length} productos` }
			/>
			<ProductGrid products={ productCollection } />
		</Layout>
	);
};

export const pageQuery = graphql`
    query CategoryProducts($categoryId: String) {
        allProducts(filter: {category: {eq: $categoryId}}, sort: {fields: name}) {
            nodes {
                sku
                name
                price
                category
                slug
            }
        }
    }
`;

export default Category;
